export default {
	title: 'networks',
	components: [
		{ title: 'wifi_mode_client', component: 'wifi_mode_client_gen_2' },
		{ title: 'wifi_client_backup', component: 'wifi_client_backup_gen_2' },
		{ title: 'wifi_mode_ap', component: 'wifi_mode_ap_gen_2' },
		{
			title: 'range_extender',
			component: 'range_extender_g2',
			min_ver: '0.10.4',
			beta: true,
		},
		{ title: 'ethernet', component: 'ethernet_gen_2' },
		{
			title: 'outbound_websocket',
			component: 'outbound_ws',
			min_ver: '0.10.4',
		},
		{ title: 'rpc_over_udp', component: 'rpc_over_udp', min_ver: '0.14.0' },
		{ title: 'cloud', component: 'cloud_gen_2' },
		{ title: 'mqtt', component: 'mqtt_gen_2' },
		// Local Network Messaging (FW-1361). Rows below: visibility is suppressed for hardware
		// without shelly-lnm — see `LOCAL_NETWORK_MESSAGING_EXCLUDED_DEVICE_TYPES` in
		// `local_network_messaging_helpers.ts` (FE-1374 unsupported-LNM device list).
		{
			// FE-1374: excluded `deviceType`s listed in local_network_messaging_helpers.ts
			title: 'local_network_messaging',
			// FE-1374: same exclusion list as above (UI must not offer LNM on those models)
			component: 'local_network_messaging_g2',
			// FE-1374: min FW shipping LNM dynamic component (confirm with FW before release)
			min_ver: '2.0.0',
		},
	],
};
